import { render, staticRenderFns } from "./KnowledgeBaseManagement.vue?vue&type=template&id=6a4192e3&scoped=true&xmlns%3Abackground-color=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./KnowledgeBaseManagement.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseManagement.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBaseManagement.vue?vue&type=style&index=0&id=6a4192e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4192e3",
  null
  
)

export default component.exports